/** @jsxImportSource @emotion/react */
import { Box } from '@mui/material'
import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import {
  contentWrapper,
  mainContentArea,
  pageContentContainer,
  shellContainer,
} from './RiskLayout.style'
import PublicRiskStoriesBrandedTopBar from './PublicRiskStoriesBrandedTopBar'
import AppLoaderRefactored from '@app/routes/App/AppLoaderRefactored'

const PublicRiskStoryLayout = ({ children }: { children?: React.ReactNode }) => {
  const location = useLocation()
  const showTopBar = location.pathname.includes('/chapter')
  return (
    <>
      <Box css={shellContainer}>
        {showTopBar && <PublicRiskStoriesBrandedTopBar />}
        <Box css={contentWrapper}>
          <Box component="main" css={mainContentArea}>
            <Box css={pageContentContainer}>
              <Outlet />
              {children}
            </Box>
          </Box>
        </Box>
      </Box>
      <AppLoaderRefactored />
    </>
  )
}
export default PublicRiskStoryLayout
